import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAuthorization from './state/authorization.reducer';
import { AuthorizationService } from './service';
import { EffectsModule } from '@ngrx/effects';
import { AuthorizationEffects } from './state/authorization.effects';
import { AuthorizationFacade } from './facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAuthorization.AUTHORIZATION_KEY, fromAuthorization.reducer),
    EffectsModule.forFeature([AuthorizationEffects])
  ],
  providers: [AuthorizationService]
})
export class SharedAuthorizationModuleForRoot {}

export class SharedAuthorizationModule {
  static forRoot(): ModuleWithProviders<SharedAuthorizationModuleForRoot> {
    return {
      ngModule: SharedAuthorizationModuleForRoot,
      providers: [AuthorizationFacade]
    };
  }
}
